import { type ReactNode } from 'react'
import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import styles from './StatCard.module.css'

interface Props {
  etichetta: string
  valore: ReactNode
  unita?: string
  delta?: number
  deltaSuffisso?: string
  invertiSegno?: boolean
}

export function StatCard({ etichetta, valore, unita, delta, deltaSuffisso, invertiSegno }: Props) {
  let direzione: 'su' | 'giu' | 'stabile' = 'stabile'
  if (delta != null) {
    if (delta > 0.05) direzione = 'su'
    else if (delta < -0.05) direzione = 'giu'
  }

  // Se invertiSegno (es. churn) il "su" è negativo
  const positivo = invertiSegno ? direzione === 'giu' : direzione === 'su'
  const coloreDelta =
    direzione === 'stabile' ? 'neutro' : positivo ? 'verde' : 'rosso'

  return (
    <div className={styles.card}>
      <div className={styles.etichetta}>{etichetta}</div>
      <div className={styles.valore}>
        <span className={styles.numero}>{valore}</span>
        {unita && <span className={styles.unita}>{unita}</span>}
      </div>
      {delta != null && (
        <div className={`${styles.delta} ${styles[coloreDelta]}`}>
          {direzione === 'su' && <TrendingUp size={14} />}
          {direzione === 'giu' && <TrendingDown size={14} />}
          {direzione === 'stabile' && <Minus size={14} />}
          <span>
            {delta > 0 ? '+' : ''}
            {delta}% {deltaSuffisso}
          </span>
        </div>
      )}
    </div>
  )
}
